import { ReactNode, FC } from 'react';
import { IonContent, IonPage } from '@ionic/react';

import appBg from 'static/assets/img/background-image.jpeg';
import { TabMenu, TabMenuProps } from './TabMenu';
import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
  usePadding?: boolean;
  showMenu?: boolean;
  children?: ReactNode;
  menuProps?: TabMenuProps;
};

export const PageWrapper: FC<Props> = ({ className = '', children, usePadding = true, showMenu = true, menuProps }) => {
  return (
    <IonPage>
      <IonContent>
        <div
          className={twMerge(`h-full w-full bg-cover ${usePadding ? 'content-section' : ''} ${showMenu ? '!pb-24' : ''}`, className)}
          style={{ backgroundImage: `url('${appBg}')` }}
        >
          {children}
        </div>

        {showMenu && menuProps && (
          <TabMenu mainButtonText={menuProps.mainButtonText} mainButtonClass={menuProps.mainButtonClass} icon={menuProps.icon} onMainClick={menuProps.onMainClick} />
        )}
      </IonContent>
    </IonPage>
  );
};
